import React, { useRef } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form, Row, Col, Card, Button } from 'react-bootstrap';
import { FaSave } from 'react-icons/fa';

const ESTAGIO_OPTIONS = [
  { value: '1', label: '1-Estudos' },
  { value: '2', label: '2-Aprovação' },
  { value: '3', label: '3-Obras' },
  { value: '4', label: '4-Registro' },
  { value: '5', label: '5-Lançamento' },
  { value: '6', label: '6-Finalizado' },
];

const validationSchema = Yup.object({
  estagio: Yup.string().required('Necessário informar Estágio'),
});

const FormProjeto = ({ dados, permissoes, onSalvar }) => {
  const dtLancOriginal = useRef(dados != null ? dados.dt_lanc : null);

  const initialValues = {
    codigo_familia: dados != null ? dados.codigo_familia : '',
    area: dados != null && dados.area != null ? dados.area : '',
    custo_lote: dados != null && dados.custo_lote != null ? dados.custo_lote : '',
    venda_lote: dados != null && dados.venda_lote != null ? dados.venda_lote : '',
    dt_lanc: dados != null && dados.dt_lanc != null ? dados.dt_lanc : '',
    estagio: dados != null && dados.estagio != null ? dados.estagio : '',
    prev_lotes: dados != null && dados.prev_lotes != null ? dados.prev_lotes : '',
    pm_vendas: dados != null && dados.pm_vendas != null ? dados.pm_vendas : '',
    tam_medio: dados != null && dados.tam_medio != null ? dados.tam_medio : '',
    tam_padrao: dados != null && dados.tam_padrao != null ? dados.tam_padrao : '',
    aproveita: dados != null && dados.aproveita != null ? dados.aproveita : '',
    valor_m2: dados != null && dados.valor_m2 != null ? dados.valor_m2 : '',
    exp_taxa: dados != null && dados.exp_taxa != null ? dados.exp_taxa : '',
    exp_tipo: dados != null && dados.exp_tipo != null ? dados.exp_tipo : '',
    centro_receita: dados != null && dados.centro_receita != null ? dados.centro_receita : '',
    entrega: dados != null && dados.entrega != null ? dados.entrega : '',
    latitude: dados != null && dados.latitude != null ? dados.latitude : '',
    longitude: dados != null && dados.longitude != null ? dados.longitude : '',
    data_registro: dados != null && dados.data_registro != null ? dados.data_registro : '',
    obs: dados != null && dados.obs != null ? dados.obs : '',
  };

  const camposDesabilitados = !permissoes.projeto;

  const handleSubmit = (values) => {
    onSalvar({ ...values, dt_lanc_anterior: dtLancOriginal.current });
  };

  return (
    <Card className="mb-3">
      <Card.Header className="py-2">
        <strong>Dados do Projeto</strong>
      </Card.Header>
      <Card.Body>
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit: formikSubmit }) => (
            <Form onSubmit={formikSubmit}>
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Área total m²</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="area"
                      value={values.area}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Custo por lote</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="custo_lote"
                      value={values.custo_lote}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Valor de venda por lote</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="venda_lote"
                      value={values.venda_lote}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Data Lançamento</Form.Label>
                    <Form.Control
                      size="sm"
                      type="date"
                      name="dt_lanc"
                      value={values.dt_lanc}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>
                      Estágio <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      as="select"
                      name="estagio"
                      value={values.estagio}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={camposDesabilitados}
                      isInvalid={touched.estagio && !!errors.estagio}
                    >
                      <option value="">Selecione...</option>
                      {ESTAGIO_OPTIONS.map((op) => (
                        <option key={op.value} value={op.value}>
                          {op.label}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.estagio}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Previsão de lotes</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      name="prev_lotes"
                      value={values.prev_lotes}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>PM Vendas</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="pm_vendas"
                      value={values.pm_vendas}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Tam. Médio</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="tam_medio"
                      value={values.tam_medio}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Tam. Padrão</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="tam_padrao"
                      value={values.tam_padrao}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Aproveitamento %</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="aproveita"
                      value={values.aproveita}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Valor M²</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="valor_m2"
                      value={values.valor_m2}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Exp. Taxa</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.01"
                      name="exp_taxa"
                      value={values.exp_taxa}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Exp. Tipo</Form.Label>
                    <Form.Control
                      size="sm"
                      name="exp_tipo"
                      value={values.exp_tipo}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Centro Receita</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      name="centro_receita"
                      value={values.centro_receita}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Entrega</Form.Label>
                    <Form.Control
                      size="sm"
                      type="date"
                      name="entrega"
                      value={values.entrega}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Latitude</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.000001"
                      name="latitude"
                      value={values.latitude}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Longitude</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      step="0.000001"
                      name="longitude"
                      value={values.longitude}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Data Registro</Form.Label>
                    <Form.Control
                      size="sm"
                      type="date"
                      name="data_registro"
                      value={values.data_registro}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Observação</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="obs"
                      value={values.obs}
                      onChange={handleChange}
                      disabled={camposDesabilitados}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {permissoes.projeto && (
                <div className="mt-2">
                  <Button size="sm" variant="success" type="submit">
                    <FaSave className="mr-1" /> Salvar Projeto
                  </Button>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default FormProjeto;
